const router = [
  {
    path: '/projectList',
    name: 'projectList',
    props: true,
    component: () => import('@/views/setting/project/List.vue'),
    meta: {
      title: '项目信息',
      hasBack: false
    }
  },
  {
    path: '/projectList/add',
    name: 'projectAdd',
    component: () => import('@/views/setting/project/Add.vue'),
    meta: {
      title: '添加项目',
      activeMenu: '/projectList'
    }
  },
  {
    path: '/projectList/detail',
    name: 'projectDetail',
    component: () => import('@/views/setting/project/Detail.vue'),
    redirect: '/projectList',
    children: [
      {
        path: 'base',
        component: () => import('@/views/setting/project/Base.vue'),
        meta: {
          title: '项目详情',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'person',
        component: () => import('@/views/setting/project/Person.vue'),
        meta: {
          title: '项目详情',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'cad',
        component: () => import('@/views/setting/project/CadList.vue'),
        meta: {
          title: '项目详情',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'area',
        component: () => import('@/views/setting/project/AreaSet.vue'),
        meta: {
          title: '项目详情',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'subzone',
        component: () => import('@/views/setting/project/SubZone.vue'),
        meta: {
          title: '项目分区',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'owner',
        component: () => import('@/views/setting/project/Owner.vue'),
        meta: {
          title: '项目详情',
          activeMenu: '/projectList'
        }
      },
      {
        path: 'subzone/add',
        component: () => import('@/views/setting/project/AddArea.vue'),
        meta: {
          title: '新增区域',
          hasQuery: true,
          backUrl: '/projectList/detail/subzone',
          activeMenu: '/projectList'
        }
      }
    ]
  }
]

export default router
